<script>
import { h } from "vue";
import { Link } from '@inertiajs/vue3'
export default {
    name: "EventCard",
    props: {
        event: Object,
    },
    render() {
        return h("div", { class: "group relative w-full overflow-hidden rounded-2xl ring-1 ring-white/[0.08]" },
            h(Link, { href: '/event/' + this.event.id, class: "block" }, () => [
                h("img", {
                    class: "h-72 w-full object-cover transition-transform duration-700 group-hover:scale-105",
                    src: this.event.poster,
                    alt: this.event.name,
                    loading: "lazy",
                }),
                h("div", { class: 'absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/70 to-transparent px-4 pb-4 pt-16 text-left' }, [
                    h(
                        "h2",
                        { class: "truncate font-display text-lg font-semibold text-white" },
                        this.event.name
                    ),
                    h("h3", { class: "mt-0.5 flex items-center gap-1.5 text-sm text-nomad-200" }, [
                        h("span", { class: "icon-map-pin text-nomad-accent", "aria-hidden": "true" }),
                        this.event.city,
                    ]),
                ]),
            ])
        );
    },
};
</script>
